/**
 * API de productos (product.php)
 * GET / → lista | GET /{id} → por ID
 * POST / → crear | PUT|PATCH /{id} → actualizar | DELETE /{id} → eliminar
 */

import { dotoniwoofApi } from '../api/dotoniwooApi';

const BASE = '/product.php';

export const getProducts = async () => {
  try {
    const response = await dotoniwoofApi.get(BASE);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener productos:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

export const getProductById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`${BASE}/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener producto:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

export const createProduct = async (payload) => {
  try {
    const response = await dotoniwoofApi.post(BASE, payload);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear producto:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al crear producto' }
    };
  }
};

export const updateProduct = async (id, payload) => {
  try {
    const response = await dotoniwoofApi.put(`${BASE}/${id}`, payload);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar producto:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al actualizar producto' }
    };
  }
};

export const deleteProduct = async (id, firebase_UID) => {
  try {
    const response = await dotoniwoofApi.delete(`${BASE}/${id}`, {
      data: { firebase_UID },
      params: { firebase_UID }
    });
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar producto:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al eliminar producto' }
    };
  }
};
